export * from './PrimeBanner';
